import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to track page visits for logged-in users
 * Automatically sends page visit data to the backend for analytics
 */
export const usePageTracking = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    const trackPageVisit = async () => {
      // Only track if path changed (avoid duplicate tracking on re-renders)
      if (lastTrackedPath.current === location.pathname) {
        return;
      }
      
      lastTrackedPath.current = location.pathname;
      
      // Check if user is logged in
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }

      // Don't track certain pages
      const excludedPaths = ['/login', '/register', '/forgot-password', '/reset-password'];
      if (excludedPaths.some(path => location.pathname.startsWith(path))) {
        return;
      }

      try {
        await axios.post(
          `${API_URL}/api/track/page-visit`,
          {
            page: location.pathname,
            referrer: document.referrer || null
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
      } catch (error) {
        // Silently fail - tracking should not break the app
        console.debug('Page tracking failed:', error.message);
      }
    };

    trackPageVisit();
  }, [location.pathname]);
};

export default usePageTracking;
